var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cx } from '@emotion/css';
import { Container } from '@mui/material';
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Input, InputSubtitle, InputTitle } from '../../../atoms/formInputs';
import { useStyles } from './InputField.styles';
export function InputField(_a) {
    var { className, id, maxWidth: propsMaxWidth, inTable, warning, role, width, inline, required, subtitle, title, fullWidth, removeNumberArrows, customTitleEndAdornment } = _a, inputProps = __rest(_a, ["className", "id", "maxWidth", "inTable", "warning", "role", "width", "inline", "required", "subtitle", "title", "fullWidth", "removeNumberArrows", "customTitleEndAdornment"]);
    const classes = useStyles();
    const maxWidth = fullWidth || propsMaxWidth === 'default' ? false : propsMaxWidth;
    const containerStyle = {
        width: width || inline ? '180px' : undefined,
        display: inline ? 'inline-block' : undefined,
    };
    const idWithSuffix = (suffix) => 
    // We keep the name "FormInput" in IDs for backward compatibility
    id ? `FormInput__${id}__${suffix}` : undefined;
    const containerId = idWithSuffix('container');
    return (React.createElement(Container, { disableGutters: true, maxWidth: maxWidth, style: containerStyle, role: role, className: cx(className, classes.root, {
            [classes.rootBoundary]: !!customTitleEndAdornment,
            [classes.inTable]: inTable,
            [classes.numberArrowsRemoved]: removeNumberArrows,
            [classes.warning]: warning, // TODO: Move to Input
        }), id: containerId },
        React.createElement("div", null,
            React.createElement(InputTitle, { className: cx(classes.InputTitle, {
                    withPadding: !subtitle,
                }), title: title, required: required, endAdornment: customTitleEndAdornment }),
            React.createElement(InputSubtitle, { className: classes.InputSubtitle, subtitle: subtitle })),
        React.createElement(Input, Object.assign({ id: id, width: width, fullWidth: fullWidth }, inputProps))));
}
//# sourceMappingURL=InputField.js.map